import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  onRetry: () => void;
};

const Root = styled.div`
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const Title = styled(T.Heading6)`
  color: ${cbSemanticCssVars.textPrimary};
`;

const Description = styled(T.Body3)`
  color: ${cbSemanticCssVars.textSecondary};
`;

const ErrorPage = ({ onRetry }: Props) => {
  return (
    <Root>
      <Content>
        <Title>
          <FormattedMessage id="insights.error-page.title" />
        </Title>
        <Description>
          <FormattedMessage id="insights.error-page.description" />
        </Description>
      </Content>
      <Button onClick={onRetry} size="small" variant="secondary">
        <FormattedMessage id="insights.error-view.try-again" />
      </Button>
    </Root>
  );
};
export default ErrorPage;
